export default {
      id: "ic_chevron_right-usage",
      viewBox: "0 0 21 20",
      url: "/" + "images/icons.3.109.2.svg#ic_chevron_right-usage",
      toString: function () {
        return this.url;
      }
    }